'use strict';

var Backbone = require('backbone');

export default Backbone.View.extend({

  tagName: 'th',
  className: 'date-picker-header-day',
  attributes: {
    tabindex: '0',
  },

  initialize: function (options) {
    this.start = options.start;
  },

  render: function () {
    this.$el.html('<span>' + this.start.format('dd') + '</span>');
    return this;
  },

});
